var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParentChildReadingTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 118,
    viewBox: "0 0 170 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 98.6154,
    height: 98.6154,
    rx: 16,
    transform: "matrix(0.861934 0.50702 -0.861934 0.50702 85 18)",
    fill: "#29B2EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 98.6154,
    height: 98.6154,
    rx: 16,
    transform: "matrix(0.861934 0.50702 -0.861934 0.50702 85 10)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_805_9534)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 85,
    cy: 70,
    rx: 30,
    ry: 10,
    fill: "#29B1EA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.666 34.9999C106.269 34.9999 110 31.269 110 26.6666C110 22.0642 106.269 18.3333 101.666 18.3333C97.064 18.3333 93.333 22.0642 93.333 26.6666C93.333 31.269 97.064 34.9999 101.666 34.9999Z",
    fill: "url(#paint0_linear_805_9534)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0837 25.8333C77.8366 25.8333 82.5003 21.1696 82.5003 15.4167C82.5003 9.6637 77.8366 5 72.0837 5C66.3307 5 61.667 9.6637 61.667 15.4167C61.667 21.1696 66.3307 25.8333 72.0837 25.8333Z",
    fill: "url(#paint1_linear_805_9534)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.963 38.3367C97.208 38.245 92.9463 40.3684 90.1363 43.7434C87.8047 35.3217 79.7663 29.2734 70.433 30.0717C60.653 30.9067 53.333 39.4767 53.333 49.2934V68.3334C53.333 70.175 54.8247 71.6667 56.6663 71.6667H113.333C115.175 71.6667 116.666 70.175 116.666 68.3334V53.8717C116.666 45.6117 110.221 38.495 101.963 38.3367Z",
    fill: "url(#paint2_linear_805_9534)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.632 46.6682C91.02 47.1166 85 51.6316 85 51.6316V71.6666H101.667C102.587 71.6666 103.333 70.9199 103.333 69.9999V48.3349C103.333 47.3999 102.565 46.6282 101.632 46.6682Z",
    fill: "url(#paint3_linear_805_9534)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3687 46.6682C78.9803 47.1166 85.0003 51.6316 85.0003 51.6316V71.6666H68.3337C67.4137 71.6666 66.667 70.9199 66.667 69.9999V48.3349C66.667 47.3999 67.4353 46.6282 68.3687 46.6682Z",
    fill: "url(#paint4_linear_805_9534)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_805_9534",
    x: 31,
    y: 36,
    width: 108,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_805_9534"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_805_9534",
    x1: 100.165,
    y1: 18.5983,
    x2: 103.268,
    y2: 35.2716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D61A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_805_9534",
    x1: 69.3687,
    y1: 6.23833,
    x2: 75.3703,
    y2: 26.5267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D61A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_805_9534",
    x1: 76.028,
    y1: 27.6584,
    x2: 87.7447,
    y2: 70.2367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D61A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_805_9534",
    x1: 103.488,
    y1: 59.1666,
    x2: 84.3367,
    y2: 59.1666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA2E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32BDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_805_9534",
    x1: 66.512,
    y1: 59.1666,
    x2: 85.6637,
    y2: 59.1666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA2E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32BDEF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentChildReadingTile);
export default __webpack_public_path__ + "static/media/parentChildReadingTile.f018d4cc554c44b5b355d2a73e03caae.svg";
export { ForwardRef as ReactComponent };